export default "__VITE_ASSET__d01ca5b3__"